import { Grid } from "@mui/material";

import useCollapseDrawer from "~src/hooks/useCollapseDrawer";
import { TrendingBrandsTile } from "../brands/trending/TrendingBrandTile";
import { BrandSearchContext } from "./useSearchBrands";
import { SkeletonCard } from "~src/components/SkeletonCard";
import ContentBox from "~src/components/ContentBox";
import EmptyContent from "~src/components/EmptyContent";
import BottomScrollListener from "~src/components/BottomScrollListener";

export const SearchBrandList = ({
  brandSearchContext,
}: {
  brandSearchContext: BrandSearchContext;
}) => {
  const { isCollapse } = useCollapseDrawer();
  const { data, loadMore, loading } = brandSearchContext;
  if ((!data || data.length <= 0) && loading === false) {
    return (
      <ContentBox>
        <EmptyContent
          title="No brands"
          description="Try using some another search term."
        />
      </ContentBox>
    );
  }
  return (
    <Grid container spacing={2}>
      {data.map((brand, index) => (
        <Grid key={index} size={{ xs: 12, md: isCollapse ? 3 : 4 , sm: 6 }}  >
          <TrendingBrandsTile brand={brand} />
        </Grid>
      ))}
      {loading &&
        Array(4)
          .fill(null)
          .map((_, index) => (
            <Grid key={index} size={{ xs: 12, md: isCollapse ? 3 : 4 , sm: 6 }}  >
              <SkeletonCard key={index} />
            </Grid>
          ))}
      <BottomScrollListener
        offset={400}
        onBottom={() => {
          loadMore();
        }}
      />
    </Grid>
  );
};
